module.exports = __webpack_public_path__ + "img/header-kontakt-icon.bf375cc3.svg";